// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEFaceToFaceEnvDesc from "./components/dialogs/f2f/PEFaceToFaceEnvDesc";
import PEF2FDialogSegmentArray from './components/dialogs/f2f/PEF2FDialogSegmentArray';

const PEFaceToFaceInteraction = (props) => {
  const { control, formState, setValue, getValues } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  console.log('form', getValues());

  return (
    <div>
      <NumberedHeading number="1" title="Character/Scene Description" instructions="Add the information for the character and the scene." />      
      <Controller
        control={control}
        name="content.env_desc"
        render={({ field }) => <PEFaceToFaceEnvDesc inputDir={inputDir} errors={errors.content?.env_desc} {...{ control }} />}
      />

      <NumberedHeading number="2" title="Face To Face Dialog Segment" instructions="Add 1 segment per" />      
      <Controller
        control={control}
        name="content.dialog_segments"
        render={({ field }) => <PEF2FDialogSegmentArray inputDir={inputDir} {...{ control, errors, setValue }} />}
      />
    </div>
  )
}

export default PEFaceToFaceInteraction;